export const GA_BANNER_CATEGORY_OTHER = 'Others';
